module.exports = __webpack_public_path__ + "static/media/banner-alert.316e2b1e.jpg";